const fallbackReturnTo = "/minha-conta";
const canonicalMemberPath =
  /^\/minha-conta(?:\/[A-Za-z0-9_-]+)*$/u;
const canonicalAdminPath = /^\/admin(?:\/[A-Za-z0-9_-]+)*$/u;
const encodedStructuralCharacter =
  /%(?:00|0[0-9a-f]|1[0-9a-f]|25|2e|2f|5c|7f)/iu;
const malformedPercentEncoding = /%(?![0-9a-f]{2})/iu;
const originLikeValue = /^(?:\/\/|[a-z][a-z0-9+.-]*:)/iu;
const rawDotSegment = /(?:^|\/)\.{1,2}(?:\/|$)/u;

function hasControlCharacter(value: string): boolean {
  for (let index = 0; index < value.length; index += 1) {
    const codeUnit = value.charCodeAt(index);
    if (codeUnit <= 31 || codeUnit === 127) {
      return true;
    }
  }
  return false;
}

function hasUnsafeQuery(destination: URL): boolean {
  for (const [key, value] of destination.searchParams) {
    if (
      hasControlCharacter(key) ||
      hasControlCharacter(value) ||
      key.includes("\\") ||
      value.includes("\\") ||
      originLikeValue.test(key.trim()) ||
      originLikeValue.test(value.trim())
    ) {
      return true;
    }
  }
  return false;
}

export function safeReturnTo(
  input: unknown,
  options: { readonly allowAdmin?: boolean } = {},
): string {
  if (
    typeof input !== "string" ||
    !input.startsWith("/") ||
    input.startsWith("//") ||
    input.includes("\\") ||
    input.includes("#") ||
    hasControlCharacter(input) ||
    encodedStructuralCharacter.test(input) ||
    malformedPercentEncoding.test(input) ||
    rawDotSegment.test(input.split("?", 1)[0] ?? "")
  ) {
    return fallbackReturnTo;
  }

  try {
    const destination = new URL(input, "https://member-return.invalid");
    if (
      destination.origin !== "https://member-return.invalid" ||
      !(canonicalMemberPath.test(destination.pathname) ||
        (options.allowAdmin === true && canonicalAdminPath.test(destination.pathname))) ||
      hasUnsafeQuery(destination)
    ) {
      return fallbackReturnTo;
    }

    return `${destination.pathname}${destination.search}`;
  } catch {
    return fallbackReturnTo;
  }
}
